import { render } from "./MonsterAbilities.vue?vue&type=template&id=fc2cd0c0&scoped=true"
import script from "./MonsterAbilities.vue?vue&type=script&lang=js"
export * from "./MonsterAbilities.vue?vue&type=script&lang=js"

import "./MonsterAbilities.vue?vue&type=style&index=0&id=fc2cd0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2cd0c0"]])

export default __exports__